module.exports = __webpack_public_path__ + "img/user_profile.424ff7b4.svg";